// extracted by mini-css-extract-plugin
export default {"container":"S4Q11hfcNGVfhl4FESYW","colorTag":"izIg4ucwuTVl7FdRKsjk","hidden":"anIjAYhxScI7c8lre_pK"};